jQuery(document).ready(function ($) {
  // Our testimonials slider
  $('.our_testimonials__slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 8000,
    arrows: false,
    dots: true,
    adaptiveHeight: true
  });
  // Our testimonials slider end

  // Team Brand slider
  $('.team_brand__slider').slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: false,
    dots: false,
    variableWidth: true,
    adaptiveHeight: true,
      responsive: [
        {
          breakpoint: 989,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            variableWidth: false
          }
        }
      ]
  });
  // Team Brand slider end

  // Hero banner and icons slider
  let windowWidth = $(window).width();
  function bannerGridSlider() {
    $('.banner-grid, .icons-grid').each(function () {
      var $slider = $(this);
      if (windowWidth <= 991) {
        if (!$slider.hasClass('slick-initialized')) {
          $slider.slick({
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 4000,
            arrows: false,
            dots: true,
            adaptiveHeight: true,
            responsive: [
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1
                }
              }
            ]
          });
        }
      } else {
        if ($slider.hasClass('slick-initialized')) {
          $slider.slick('unslick');
        }
      }
    });
  }
  bannerGridSlider();
  $(window).on('resize', function () {
    let newWidth = $(window).width();
    if (newWidth !== windowWidth) {
      windowWidth = newWidth;
      bannerGridSlider();
    }
  });
  // Hero banner and icons slider end

  // Insta post slider
  function instaPostSlider() {
    if ($(window).width() <= 1199) {
      if (!$('.our_testimonials__btm').hasClass('slick-initialized')) {
        $('.our_testimonials__btm').slick({
          slidesToShow: 3,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 4000,
          arrows: false,
          dots: false,
          adaptiveHeight: true,
          responsive: [
            {
              breakpoint: 991,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
        });
      }
    } else {
      if ($('.our_testimonials__btm').hasClass('slick-initialized')) {
        $('.our_testimonials__btm').slick('unslick');
      }
    }
  }
  instaPostSlider();
  $(window).on('resize', function () {
    instaPostSlider();
  });
  // Insta post slider end
  

});


// jQuery(document).ready(function ($) {
//   const $items = $('.our_clients__item');
//   let isEnabled = window.innerWidth > 767;
//   function resetItems() {
//     $items.removeClass('item_expanded').show();
//   }
//   function updateState() {
//     isEnabled = window.innerWidth > 767;
//     if (!isEnabled) {
//       resetItems();
//     }
//   }
//   updateState();
//   $(window).on('resize', function () {
//     updateState();
//   });
//   $items.on('mouseenter', function () {
//     if (!isEnabled) return;
//     const index = $items.index(this);
//     const winWidth = window.innerWidth;
//     resetItems();
//     this.offsetHeight;
//     $(this).addClass('item_expanded');
//     /* ≥ 1400px (6 cols) */
//     if (winWidth >= 1400) {
//       if ((index + 1) % 6 === 0) $items.eq(index - 1).hide();
//       if ((index + 1) % 6 === 5) $items.eq(index + 1).hide();
//     }
//     /* 1200–1399px (4 cols) */
//     else if (winWidth >= 1200) {
//       if ((index + 1) % 4 === 0) $items.eq(index - 1).hide();
//     }
//     /* 990–1199px (3 cols) */
//     else if (winWidth >= 990) {
//       if ((index + 1) % 3 === 0) $items.eq(index - 1).hide();
//     }
//     /* 768–989px (2 cols) */
//     else if (winWidth >= 768) {
//       if ((index + 1) % 2 === 0) $items.eq(index - 1).hide();
//     }
//   });
//   $items.on('mouseleave', function () {
//     if (!isEnabled) return;
//     resetItems();
//   });
// });
